export const MODAL_COMPONENT_PROPS = {
    root:{
        className:'muiModalCustom muiModalCustomWidgets'
    }
}